import React, { useState, useEffect, FC } from "react";
import UserLink from "../../utils/UserLink";
import { connect } from "react-redux";
import { selectTrack, selectedTrack } from "../../store/actions/track";
import { playOrPause } from "../../store/actions/audio";
import { storage, firestore } from "../../firebase";
import { playsCounter, likeSong } from "../../store/actions/songs";
import { RootState } from "../../store/reducers";
import { Track } from "../../models/track";

interface PropActions {
  selectedTrack: Function;
  playOrPause: Function;
  selectTrack: Function;
}

interface PropState {
  paused: boolean;
  current: Track;
  uid: string;
}
interface Props {
  track: Track;
}

const AppUICard: FC<Props & PropState & PropActions> = ({
  track,
  paused,
  current,
  selectTrack,
  selectedTrack,
  playOrPause,
  uid,
}) => {
  const { title, id, username, covername } = track;
  const [likes, setLikes] = useState<string[]>([]);
  let liked = likes.includes(uid);
  // const [following, setFollowing] = useState(false)
  const [cover, setCover] = useState("");
  const [plays, setPlays] = useState([]);
  const [played, setPlayed] = useState(false);

  const selectSong = (song: Track) => {
    if (played !== null && !played && id) {
      playsCounter(id, uid);
    }

    if (current.id !== id) {
      selectTrack(song);
      playOrPause();
    } else {
      selectTrack(song);
      playOrPause();
    }
  };

  useEffect(() => {
    // let loggedIn = firebase.auth().currentUser
    let mounted = true;

    if (covername) {
      storage
        .ref(`covers/${track.uid}${covername}`)
        .getDownloadURL()
        .then((url) => {
          if (mounted) setCover(url);
        });
    }

    firestore
      .collection("songs")
      .doc(id)
      .onSnapshot((snap) => {
        if (snap.exists) {
          const data = snap?.data();
          if (mounted) {
            setLikes(data?.likes);

            if (uid !== null) {
              setPlays(data?.plays);
              setPlayed(data?.plays.includes(uid));
            } else {
              setPlayed(false);
            }
          }
        }
      });

    // if (loggedIn !== null) {
    //   firebase
    //     .firestore()
    //     .collection("users")
    //     .where("username", "==", username)
    //     .onSnapshot((snap) => {
    //       if (!snap.empty) {
    //         snap.forEach((doc) => {
    //           const fans = doc.data().fans
    //           if (fans.includes(loggedIn.uid)) {
    //             if (mounted) {
    //               setFollowing(true)
    //             }
    //           } else {
    //             if (mounted) {
    //               setFollowing(false)
    //             }
    //           }
    //         })
    //       }
    //     })
    // }

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [track]);

  return (
    <div className="extra-card" uk-scrollspy="cls: uk-animation-scale-up">
      <div className="etop">
        <div>
          <UserLink params={{ username }}>@{username}</UserLink>
        </div>
        <div>
          <small>{title}</small>
        </div>
      </div>
      <div
        className="ebot"
        style={{ background: cover ? `url(${cover})` : `#ddd` }}
      >
        <div>
          <div
            onClick={() => {
              selectSong(track);
            }}
          >
            <i className="material-icons-outlined">
              {current.id !== id || paused ? "play_arrow" : "pause"}
            </i>

            <span className="uplays">{plays.length}</span>
          </div>
          <div className="eactions">
            <span
              style={{ color: liked ? `var(--theme-color)` : "" }}
              onClick={() => {
                if (id) likeSong(id);
              }}
            >
              <small>{likes.length}</small>
              <i className="material-icons-outlined">favorite_border</i>
            </span>
            <span
              uk-toggle="target: #track-modal"
              onClick={() => selectedTrack(track)}
            >
              <i className="material-icons-outlined">more_horiz</i>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState): PropState => ({
  paused: state.songs.paused,
  current: state.songs.current,
  uid: state.auth.user.id,
});

const mapDispatchToProps = {
  selectTrack,
  selectedTrack,
  playOrPause,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppUICard);
